/** * チェックアウト編集コンポーネント */
<template>
  <ifield-b-modal
    v-bind:id="modalId"
    ref="checkout-editor-dialog-modal"
    v-bind:title="$t('theCheckoutEditor.title')"
    centered
    scrollable
    no-body-border
    size="lg"
    ok-variant="success"
    ignore-enforce-focus-selector=".popover"
  >
    <template v-slot:default>
      <loading-mask isFullScreen v-bind:isLoading="isSaving" />
      <form-group
        id="checkout-form"
        ref="form-group"
        class="form-group-top"
        v-on:form-group-value-change="$_onFormValueChanged"
      />
    </template>

    <!-- modal footer -->
    <template v-slot:modal-footer="{ cancel }">
      <!-- 編集ボタン -->
      <b-button
        size="sm"
        variant="success"
        v-t="'theCheckoutEditor.action.checkout'"
        v-on:click="$_onClickCheckout"
      />
      <b-button
        size="sm"
        variant="secondary"
        v-t="'theCheckoutEditor.action.close'"
        v-on:click="cancel"
      />
    </template>
  </ifield-b-modal>
</template>

<script>
import { ATTRIBUTE_TYPE } from 'ifield-core-components'
import { RestApiClient } from 'ifield-core-components'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'

// フィールド名
const FIELD_NAME = 'remarks'

/**
 * チェックアウト編集コンポーネント
 */
export default {
  name: 'TheCheckoutEditor',
  props: {
    /**
     * DOMのidのプレフィックス
     */
    idPrefix: {
      type: String,
      default: '',
    },
    /**
     * チェックインID
     */
    checkinId: {
      type: Number,
      default: null,
    },
  },
  setup(props, context) {
    const { handleApiError } = useHandleApiError(props, context)
    return { handleApiError }
  },
  data: function () {
    return {
      /**
       * 保存中フラグ
       * @type {Boolean}
       */
      isSaving: false,
    }
  },
  computed: {
    /**
     * モーダルのID
     * @type {String}
     */
    modalId: function () {
      return `${this.idPrefix}-checkout-editor-dialog`
    },

    /**
     * フォーム用データ(定型分)
     * @type {Array.<Object>}
     */
    forms: function () {
      return [
        {
          // コメント
          fieldName: FIELD_NAME,
          label: this.$t('theCheckoutEditor.label.comment'),
          attributeType: ATTRIBUTE_TYPE.TEXT,
          value: null,
          placeholder: this.$t('theCheckoutEditor.placeholder.inputComment'),
        },
      ]
    },
  },
  mounted: function () {
    this.$log.debug('checkout editor mounted!')
  },
  methods: {
    /**
     * プレイス編集コントロールを作成
     */
    showModal: async function () {
      this.$bvModal.show(this.modalId)
      await this.$nextTick().then(() => {
        this.$_setData()
      })
    },

    /**
     * データをフォームにセットする一連の処理ラッパー
     */
    $_setData: function () {
      this.$_setDataToForm()
    },

    /**
     * フォームにデータをセットする
     */
    $_setDataToForm: function () {
      this.$refs['form-group'].setData(this.forms)
    },

    /**
     * フォームの値変更時の処理
     * @param {String} fieldName フォームのフィールド名
     * @param {String} value フォームの値
     */
    $_onFormValueChanged: function (fieldName, value) {
      if (fieldName === FIELD_NAME) this.comment = value
    },

    /**
     * チェックアウトボタン押下時の処理
     */
    $_onClickCheckout: async function () {
      // URL
      const url = RestApiClient.createApiUrl(
        `checkin/checkout/${this.checkinId}`
      )
      const body = {
        comment: this.comment || null,
      }

      this.$_showSaveLoading()

      try {
        await RestApiClient.executePutApi(url, body)
        /**
         * チェックアウトコメント編集完了イベント
         */
        this.$emit('checkout-editend')

        // コメント編集モーダルを閉じる
        this.$bvModal.hide(this.modalId)
      } catch (error) {
        this.handleApiError(error)
      } finally {
        this.$_hideSaveLoading()
      }
    },

    /**
     * 保存時のローディングを表示する
     */
    $_showSaveLoading: function () {
      this.isSaving = true
    },

    /**
     * 保存時のローディングを非表示にする
     */
    $_hideSaveLoading: function () {
      this.isSaving = false
    },
  },
}
</script>

<style lang="scss" scoped>
.form-group-top {
  padding-bottom: 0 !important;
}
</style>
